import { getReelSpinAction } from 'automaton/actions/ReelSpinAction'
import { getRequestSpinAction } from 'automaton/actions/RequestSpinAction'
import { getBetState } from 'automaton/states/BetState'
import { getFreeBetState } from 'automaton/states/FreeBetState'
import { getRespinState } from 'automaton/states/RespinState'
import { getWinState } from 'automaton/states/WinState'

import { getCascadeState } from './CascadeState'

export function getFreeBetSpinState() {
  game.models.ModeModel.respinIntro = true
  const freeBetModel = game.models.FreebetsModel.get()
  const winModel = game.models.WinModel.get()
  const spinModel = game.models.SpinModel.get()
  const cascadeModel = game.models.CascadeModel.get()
  const name = 'FB-SPIN'
  const actions = [
    getRequestSpinAction(),
    getReelSpinAction(),
  ]
  const transition = () => cascadeModel.all > -1 ? getCascadeState() : winModel.winLines.length
    ? getWinState()
    : spinModel.respin.length
      ? getRespinState()
      : freeBetModel.rest ? getFreeBetState() : getBetState()

  return {
    name,
    actions,
    transition,
  }
}
